/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const pushItemsRequestSchema = z.object({
  itemIds: z
    .array(z.int())
    .min(1)
    .max(100)
    .refine((items) => new Set(items).size === items.length, {
      message: 'Array entries must be unique',
    })
    .describe(
      'Item store item IDs to sync. The preferred way to scope a sync: the service resolves them to source system item IDs itself, so callers do not need to know them. Omit both fields to push every item changed in Loop since the last pull.',
    )
    .nullish(),
  sourceItemIds: z
    .array(z.string())
    .min(1)
    .max(100)
    .refine((items) => new Set(items).size === items.length, {
      message: 'Array entries must be unique',
    })
    .describe(
      'Source system item IDs (e.g. Jira issue IDs) to sync. For items that have no item store item ID, such as one that failed to be created in Loop. An issue ID such as PROJ-123 is also accepted, since a failure recorded before the item reached Loop may only be nameable that way. May be combined with itemIds.',
    )
    .nullish(),
});
